import { IAnswer } from 'src/app/models/application-form/application-form.model';

export abstract class AbstractGoogleMapApiService {
    public addressAnswers: IAnswer[];
    abstract loadGoogleMapsApi();
}
